import React from "react";

const CRM = () => {
  return <div>This is CRM page</div>;
};

export default CRM;
